module.exports = __webpack_public_path__ + "img/hero-classics3-le_airton.78508d1.jpg";